import { ACTIONS } from './actions';

export const reducer = (state = {}, action) => {
  const RESPONSES_BREADCRUMB = 'Student Responses';
  const STUDENT_RESPONSES_BREADCRUMB = 'Your Responses';
  const QUESTION_DETAILS_BREADCRUMB = 'Question Details';
  const STUDENT_RESULTS_BREADCRUMB = 'Student Results';
  const RESULTS_OVERVIEW_BREADCRUMB = 'Results Overview';
  const MY_ASSIGNMENTS_BREADCRUMB = 'Assignments';

  const { breadCrumbs } = state;
  const hasStudentResponseRoute = breadCrumbs.some(
    (crumb) =>
      crumb.text === RESPONSES_BREADCRUMB ||
      crumb.text === STUDENT_RESPONSES_BREADCRUMB ||
      crumb.text === STUDENT_RESULTS_BREADCRUMB,
  );
  const currentBreadCrumbIndex = breadCrumbs.findIndex(
    (crumb) => crumb.text === action.payload,
  );
  const breadCrumbSlice = breadCrumbs.slice(0, currentBreadCrumbIndex + 1);
  switch (action.type) {
    case ACTIONS.addBreadCrumb:
      return {
        ...state,
        breadCrumbs: [...state.breadCrumbs, action.payload],
      };
    case ACTIONS.removeAdjacentBreadCrumbs:
      if (
        hasStudentResponseRoute &&
        action.payload === QUESTION_DETAILS_BREADCRUMB
      ) {
        // This is more specific to results where when coming from viewing the student's responses,
        // we don't want to still include the 'student responses' breadcrumb
        return {
          ...state,
          breadCrumbs: breadCrumbs
            .filter((crumb) => crumb.text !== RESPONSES_BREADCRUMB)
            .filter((crumb) => crumb.text !== STUDENT_RESPONSES_BREADCRUMB),
        };
      }
      return {
        ...state,
        breadCrumbs: breadCrumbSlice,
      };
    case ACTIONS.updateResultsOverviewRoute:
      let resourceId;
      let breadCrumbsUpdated = breadCrumbs;
      const resourcesUrl = action.payload;
      const resourcesUrlArray = resourcesUrl.split('/resources');
      resourceId = resourcesUrlArray[0];
      if (breadCrumbs.length >= 3) {
        if (breadCrumbs[2].to.includes('/students')) {
          const studentResultsUrl = breadCrumbs[2].to;
          const studentResultsArray = studentResultsUrl.split('/students');
          resourceId = studentResultsArray[0];
        }
        if (!breadCrumbs[2].to.includes('/students')) {
          if (breadCrumbs[2].text === RESULTS_OVERVIEW_BREADCRUMB) {
            breadCrumbsUpdated[2].to = resourcesUrlArray[0];
          }
        }
        if (
          breadCrumbs[0].text === MY_ASSIGNMENTS_BREADCRUMB &&
          breadCrumbs[2].text === STUDENT_RESULTS_BREADCRUMB
        ) {
          breadCrumbsUpdated[1] = {
            to: `${resourceId}/resources`,
            text: RESULTS_OVERVIEW_BREADCRUMB,
          };
        }
      }
      breadCrumbs.forEach((breadCrumb, breadCrumbIndex) => {
        // update breadcrumb if we're in the results overview page
        if (breadCrumb.text === RESULTS_OVERVIEW_BREADCRUMB && resourceId) {
          breadCrumbsUpdated[breadCrumbIndex].to = resourceId;
        }
      });
      return {
        ...state,
        breadCrumbs: breadCrumbsUpdated,
      };
    case ACTIONS.updateSingleBreadcrumb:
      const updateIndex = breadCrumbs.findIndex(
        (crumb) => crumb.text === action.payload.breadcrumb,
      );
      if (breadCrumbs[updateIndex]) {
        breadCrumbs[updateIndex].to = action.payload.to;
      }
      return {
        ...state,
        breadCrumbs,
      };
    case ACTIONS.updatePreviousPageRoute:
      breadCrumbs[0] = action.payload;

      return {
        ...state,
        breadCrumbs,
      };
    case ACTIONS.removeAllBreadCrumbs:
      return {
        ...state,
        breadCrumbs: breadCrumbs.slice(0, 2),
      };

    default:
      return state;
  }
};
